import { TRATON_BLUE } from 'src/app/theme/design-tokens';

export const menubarHeaderDesignToken = {
	padding: '0 1.5rem 0 1.5rem',
	background: TRATON_BLUE[950],
	border: {
		radius: '0',
		color: TRATON_BLUE[950],
	},
	item: {
		color: 'white',
		borderRadius: '6px',
		focus: {
			color: 'white',
			background: TRATON_BLUE[700],
		},
		active: {
			color: 'white',
			background: TRATON_BLUE[600],
		},
	},
	mobile: {
		button: {
			color: 'white',
			hover: {
				background: TRATON_BLUE[700],
				color: 'white',
			},
		},
	},
	submenu: {
		background: TRATON_BLUE[950],
	},
};
